import { api } from '../client'
import type { RequestOptions } from '../client'
import type { CriteriaAnalytics } from './types'

export const analyticsHttpApi = {
  criteria: (options?: RequestOptions): Promise<CriteriaAnalytics> =>
    api.get<CriteriaAnalytics>('/analytics/criteria', options),
}
